import { Tracks } from "@/components/project/ProjectDataSheet/Tracks"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_private/projects/$id/data/tracks/")({
  component: TracksRoute,
})

function TracksRoute() {
  const navigate = Route.useNavigate()
  const { id } = Route.useParams()
  return (
    <Tracks
      onBack={() => navigate({ to: "/projects/$id/data", params: { id } })}
    />
  )
}
